/**
 * Given a URL, removes any query parameters.
 */
export function dropQueryParams(s: string): string {
  return s.split('?')[0]
}
